import React from 'react';
import {
    CaptureButton,
    CaptureControls,
    FaceOval,
    ImageHint,
    ImagePanel,
    ScanningBadge,
} from './ProfilePictureUpload.styles';
import { PHOTO_STAGES } from './utils';

const fillStyle = { width: '100%', height: '100%', objectFit: 'cover', display: 'block' };

/**
 * The image well of the capture/preview screen: live webcam feed while capturing,
 * the uploaded photo otherwise, plus the face guide and the capture control.
 */
function PhotoImagePanel({ stage, photoUrl, videoRef, canvasRef, onCapture }) {
    const isBusy = stage === PHOTO_STAGES.UPLOADING || stage === PHOTO_STAGES.SUBMITTING;

    return (
        <ImagePanel>
            {stage === PHOTO_STAGES.WEBCAM ? (
                <video ref={videoRef} autoPlay playsInline muted style={fillStyle} />
            ) : null}

            {stage !== PHOTO_STAGES.WEBCAM && stage !== PHOTO_STAGES.UPLOADING && photoUrl ? (
                <img src={photoUrl} alt="Captured headshot preview" style={fillStyle} />
            ) : null}

            <canvas ref={canvasRef} style={{ display: 'none' }} />
            <FaceOval />

            {(stage === PHOTO_STAGES.WEBCAM || isBusy) && (
                <ScanningBadge>
                    <i className="fal fa-image"></i>{' '}
                    {stage === PHOTO_STAGES.UPLOADING ? 'Uploading your photo' : 'Scanning your photo'}
                </ScanningBadge>
            )}

            {stage === PHOTO_STAGES.WEBCAM && (
                <CaptureControls>
                    <ImageHint>Place your face in the oval and capture your photo</ImageHint>
                    <CaptureButton type="button" onClick={onCapture} aria-label="Capture Photo" />
                </CaptureControls>
            )}
        </ImagePanel>
    );
}

export default PhotoImagePanel;
